import { useState } from 'react';
import { Icon } from '../';
import { COLORS } from '../../../constants/colors';

export interface ColorButtonProps {
  color: string;
  onClick?: (color: keyof typeof COLORS) => any;
  isSelected?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isGroup?: boolean;
  radius?: number;
}

export const ColorButton = ({
  color,
  radius = 5,
  isReadOnly,
  isDisabled,
  isSelected,
  isGroup,
  onClick,
}: ColorButtonProps) => {
  const [isChecked, setIsChecked] = useState(isSelected ?? false);

  const handleClick = () => {
    if (isDisabled || isReadOnly) {
      return;
    }
    if (onClick) {
      onClick(color as keyof typeof COLORS);
    }
    setIsChecked(!isChecked);
  };

  return (
    <div
      className={`
        flex
        relative
        items-center
        justify-center
        rounded-full
        shadow-strong
        border-white
        w-${radius}
        h-${radius}
        bg-${COLORS[color]}
        ${isSelected || (!isGroup && isChecked) ? 'border-2' : 'border-0'}
        ${
          !isReadOnly && !isDisabled
            ? 'cursor-pointer hover:border-2'
            : 'cursor-default'
        }
        ${isDisabled && 'opacity-30 cursor-not-allowed'}
      `}
      onClick={handleClick}
      tabIndex={0}
    >
      <div
        className={`
          flex
          items-center
          rounded-full
          bg-gradient-to-t
          from-black
          to-transparent
          mix-blend-overlay
          w-${radius}
          h-${radius}
        `}
      ></div>

      <div
        className={`
          w-full
          p-0.5
          flex
          items-center
          absolute
          left-0
          material-icons
          text-xs
          font-extrabold
          w-${radius}
          h-${radius}
          ${
            isSelected || (!isGroup && isChecked)
              ? 'text-white '
              : 'text-transparent'
          }
        `}
      >
        <Icon svgName="check" canUseDarkMode={false} />
      </div>
    </div>
  );
};
